<template>
  <v-app>
    <!-- Add the top bar here -->
    <UploadlinkTopBar @toggleSidemenu="toggleSidemenu()">
    </UploadlinkTopBar>

    <v-main>
      <v-container fluid id="uploadlink-main-container">
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="8"
            lg="6"
            offset-md="2"
            offset-lg="3"
            class="uploadlink-upload-container"
          >
            <UploadFiles data-cy="uploadLink-link-uploadField">
            </UploadFiles>
          </v-col>
        </v-row>

        <v-row v-if="getNote" data-cy="uploadlink-view-notes">
          <v-col
            cols="12"
            sm="12"
            md="8"
            lg="6"
            offset-md="2"
            offset-lg="3"
            class="uploadlink-notes"
          >
            <div v-html="getNote" class="markdown-preview">
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { useTheme } from 'vuetify';
import { useUploadLinkStore } from '@/stores/UploadLinkStore.js';
import UploadlinkTopBar from './components/UploadlinkTopBar.vue';
import UploadFiles from './components/UploadFiles.vue';

export default {
  name: "UploadlinkView",
  components: {
    UploadlinkTopBar,
    UploadFiles,
  },
  data() {
    return {
      code: "",
    };
  },
  mounted() {
    this.code = this.$route.params.code;

    if (!this.getUploadlinkInfo) {
      this.$router.push(`/uploadaccess/${this.code}`);
      return;
    }

    const theme = useTheme();

    if (
      this.getUploadlinkInfo &&
      this.getUploadlinkInfo.brand &&
      this.getUploadlinkInfo.brand.theme &&
      this.getUploadlinkInfo.brand.theme === 'dark'
    ) {
      theme.change('dark');
    } else {
      theme.change('light');
    }
  },
  methods: {
    toggleSidemenu() {
      // Method implementation if needed
    }
  },
  computed: {
    getUploadlinkInfo() {
      const uploadLinkStore = useUploadLinkStore();
      return uploadLinkStore.getUploadlinkInfo;
    },
    getNote() {
      if (this.getUploadlinkInfo && this.getUploadlinkInfo.note) {
        return this.getUploadlinkInfo.note;
      }

      return '';
    }
  }
};
</script>

<style>
#uploadlink-main-container {
  min-height: 100%;
  padding-top: 80px;
}

@media only screen and (max-width: 600px) {
  #uploadlink-main-container {
    padding-top: 76px;
  }
}

.uploadlink-notes {
  padding: 20px;
  border-radius: 20px;
  margin-top: 20px;
  background-color: rgb(var(--v-theme-tw-surface-accent));
}

/* .v-theme--light .uploadlink-notes {
  background-color: #FFFFFF;
}

.v-theme--dark .uploadlink-notes {
  background-color: #232b36;
} */

.uploadlink-notes > div {
  background-color: inherit !important;
}

.uploadlink-upload-container {
  margin-top: 40px;
  padding: 20px;
  border-radius: 20px;

  background-color: rgb(var(--v-theme-tw-surface)) !important;
}

/* .v-theme--light .uploadlink-upload-container {
  background-color: #FFFFFF;
}

.v-theme--dark .uploadlink-upload-container {
  background-color: #232b36;
} */
</style>
